// extracted by mini-css-extract-plugin
export default {"savedListsHeader":"savedLists_savedListsHeader__KapqI"};